import http from "infra/http";
import { useQuery } from "react-query";
import { GrupoUnidadeItem } from "../typings";

function useGruposUnidades(query?: { incluirUnidades?: string; id?: string }) {
  const queryResult = useQuery(
    [`/v1/grupo-unidade`, query?.incluirUnidades],
    async () => {
      const { data } = await http.get<GrupoUnidadeItem[]>(`/v1/grupo-unidade`, {
        params: query,
      });

      return data;
    });

  return queryResult;
}

export default useGruposUnidades;
